<template>
  <div class="add-btn-box page_text_font" @click.prevent v-if="has_variant">
    <div class="add-card-div" v-if="has_variant || computed_price.buy_able">
      <button
        class="add-card-btn transition-main"
        :class="{
          active: select_active && has_variant,
          hover_active: has_variant,
        }"
        @click="toggle"
      >
        <span class="text-uppercase add">{{ $t("venue.productList.selected_options").replace(/ /g, "&nbsp;") }}</span>
        <span class="text-uppercase select">
          <span>{{ $t("venue.productList.selected_options") }}</span>
          <span class="plus"></span>
        </span>
      </button>
    </div>
    <div class="add-select-div" ref="addSelectDiv" v-if="has_variant">
      <div class="select-div-box">
        <div
          v-for="(item, index) in product_res.variant_attrs"
          :key="item.name + index"
          :style="{
            width: is_special_attr(item.special_native_name)
              ? ` calc(${
                  100 / $store.state.special_attr_num
                }% - 10px) !important`
              : '',
          }"
        >
          <v-selectStyle
            :attrs="item"
            :index="index"
            :variant_attrs="variant_attrs"
            :theme="theme"
            :show_dropdown="true"
          ></v-selectStyle>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelectStyle from "@/views/venue/js/view/product/selectStyle.vue";
export default {
  props: ["theme", "product_res", "variant_attrs", "computed_price"],
  data() {
    return {
      select_active: false,
    };
  },
  methods: {
    is_special_attr(name) {
      let { special_attr_key } = this.$store.state;
      if (!name || !special_attr_key) return false;
      else if (name.toLowerCase() == special_attr_key) return true;
    },
    toggle() {
      //若无变种 直接加购
      if (!this.has_variant) {
        this.$emit("clickAdd");
        return;
      }
      this.select_active = !this.select_active;
      this.$(this.$refs.addSelectDiv).animate({ height: "toggle" }, 300);
    },
  },
  computed: {
    has_variant() {
      let { variant_attrs } = this.product_res;
      if (variant_attrs && variant_attrs.length) return true;
    },
  },
  components: {
    vSelectStyle,
  },
};
</script>
<style scoped lang='scss'>
.add-btn-box {
  .add-card-div {
    margin-bottom: 15px;   
    .add-card-btn {
      text-align: center;
      width: 100%;
      min-height: 40px;
      font-size: 16px;
      padding: 10px;
      outline: none;
      line-height: 1.2;
      & > span {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .select {
        display: none;
        .plus {
          position: absolute;
          right: 0;
          top: 8px;
          &::after,
          &::before {
            content: "";
            position: absolute;
            right: 18px;
            height: 10px;
            top: 6px;
            border-left: 2px solid #000;
            transition: transform 250ms ease 0s;
          }
          &::after {
            transform: rotate(90deg);
          }
          &::before {
            transform: rotate(0deg);
          }
        }
      }
      .add {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        text-align: left;
      }
      &.hover_active:hover,
      &.active {
        .add {
          display: none;
        }
        .select {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          text-align: left;
        }
      }
      &.active {
        .select {
          .plus {
            &::before {
              transform: rotate(90deg);
            }
          }
        }
      }
    }
  }
  .add-select-div {
    display: none;
    margin-top: 12px;
    .select-div-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      & > div {
        width: 100%;
      }
      &::v-deep {
        .select-style-box {
          .default-select {
            select {
              height: 40px;
              line-height: 15px;
              padding: 6px;
            }
          }
        }
       }
    }
  }
}
#app {
  .add-card-div {
    .add-card-btn {
      color: var(--group-color) !important;
      border: 1px solid var(--group-background) !important;
      &::before {
        background-color: var(--group-background) !important;
      }
      &.active,&:hover {
        color: var(--group-background) !important;
      }
    }    
  }

}
@media screen and (max-width: 767px) {
  .add-btn-box {
    .add-card-div {
      .add-card-btn {
        line-height: 34px;
        min-height: unset;
        padding: 0 10px;
        & > span {
          font-size: 12px;
        }
        .select {
          .plus {
            top: 5px;
          }
        }
        .add {
          font-size: 12px;
        }
        &.hover_active:hover,
        &.active {
          .select {
            font-size: 12px;
          }
        }
      }
    }
    .add-select-div {
      .select-div-box {
        &::v-deep {
          .select-style-box {
            .default-select {
              select {
                height: 34px;
                padding: 6px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>